<p>
  <ng-container *ngIf="address?.name"><span [ngClass]="{'text-danger': invalidName}">{{address?.name}}</span><br></ng-container>  
  <ng-container *ngIf="address?.address">{{address?.address}}<br></ng-container>
  <ng-container *ngIf="address?.cityName">{{address?.cityName}}, </ng-container>
  <ng-container *ngIf="validStateName(address?.stateName)">{{address?.stateName}}, </ng-container>
  <ng-container *ngIf="address?.zipCode">{{address?.zipCode}}<br></ng-container>
  <ng-container *ngIf="address?.countryName">{{address?.countryName}}<br></ng-container>
</p>